"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Feedback = _interopRequireDefault(require("../container/Feedback"));
var _TransCustomerFeedbackAggreatorServiceClient = require("../clients/TransCustomerFeedbackAggreatorServiceClient");
/** @typedef {import("@amzn/ihm-js-coral-client").CoralClientConfigFactory} CoralClientConfigFactory */
/** @typedef {import("@amzn/ihm-js-coral-client").CoralInterceptor} CoralInterceptor */
/**
 * Get the Feedback entry point after initializing the js client
 *
 * @param {{
 *    env: string,
 *    requestOptionsInterceptor: CoralInterceptor,
 *    client: any
 * }} clientOptions - JS client options for initializing the js client
 */
var feedback = function feedback(clientOptions) {
  // Initialize the service client
  var env = clientOptions.env,
    requestOptionsInterceptor = clientOptions.requestOptionsInterceptor,
    client = clientOptions.client;
  if (client) {
    (0, _TransCustomerFeedbackAggreatorServiceClient.initCustomClient)(client);
  } else {
    (0, _TransCustomerFeedbackAggreatorServiceClient.initTransCustomerFeedbackAggreatorServiceClient)(env, requestOptionsInterceptor);
  }
  return _Feedback["default"];
};
var _default = exports["default"] = feedback;
//# sourceMappingURL=feedback.js.map